import PriceBar from './PriceBarTablet';
export default PriceBar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/PriceBar/PriceBarSub/PriceBarTablet/index.js
// module id = 2228
// module chunks = 8